/*
*
* File JS per il TPL Contatti
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './contact-page.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const initSwiperHowTo = () => {
    let swiperHowTo = document.querySelector('.info-map .swiper-container'); 

    if (!swiperHowTo) return;

    let args = {
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 26,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 26,
            },
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };

    new Swiper(swiperHowTo, args);
}
initSwiperHowTo();

//--------------------------------------------------------------------//